// Generated by web/build.mjs: a language's texts from its own files next to the script (none: English):
// what the companions say at first, and the menu's texts too once the menu is wanted (loadMenuTexts).
import { loadPart } from './designs.js';
import { language, addTexts } from '../engine/i18n.js';
let menuWanted = false;
const menuTexts = async code => { const m = await loadPart("lang-" + code + "-menu"); return m ? m.default : {}; };
export async function loadLanguage(code) {
  const m = await loadPart("lang-" + code);
  if (!m) return null;
  return menuWanted ? { ...m.default, ...(await menuTexts(code)) } : m.default;
}
export async function loadMenuTexts() { menuWanted = true; const code = language(); if (code !== "en") addTexts(code, await menuTexts(code)); }